export type LoginErrorCode = "account_disabled" | "invalid_credentials";

export class LoginError extends Error {
	readonly code: LoginErrorCode;

	constructor(code: LoginErrorCode) {
		super(code);
		this.code = code;
	}
}
